import { capitalize } from "@mui/material";
import { DayHoursList, HourType } from "src/business/restaurant/restaurant";

export const isDayOpen = (day: HourType) =>
  day.morning.start.format("HH:mm") !== "00:00" ||
  day.morning.end.format("HH:mm") !== "00:00";

export const hasEveningHours = (day: HourType) =>
  !!day.evening &&
  (day.evening.start.format("HH:mm") !== "00:00" ||
    day.evening.end.format("HH:mm") !== "00:00");

export const formateHours = (hours: DayHoursList) => {
  let result = "";
  hours.forEach((dayHour, index) => {
    const { day, morning, evening } = dayHour;
    const hasMorning =
      morning.start.format("HH:mm") !== "00:00" ||
      morning.end.format("HH:mm") !== "00:00";
    if (hasMorning) {
      result += `${capitalize(day)}=${morning.start.format("HH:mm")}-${morning.end.format("HH:mm")}`;
      if (evening) {
        result += `/${evening.start.format("HH:mm")}-${evening.end.format("HH:mm")}`;
      }
      if (index < hours.length - 1) {
        result += ";";
      }
    }
  });
  return result;
};
